/** Add/replace client's rights here */
import komacutRights from './_komacut/rights';

export default [
  '*',

  'user.create',
  'user.read',
  'user.update',
  'user.delete',

  'role.create',
  'role.read',
  'role.update',
  'role.delete',

  'address.create',
  'address.read',
  'address.update',
  'address.delete',

  'phone.create',
  'phone.read',
  'phone.update',
  'phone.delete',

  'email.create',
  'email.read',
  'email.update',
  'email.delete',

  'contact.create',
  'contact.read',
  'contact.update',
  'contact.delete',

  /** Add/replace client's rights here */
  ...komacutRights,
];
